<form *ngIf="loadLicenses" nz-row novalidate
  [formGroup]="form"
  class="card-container-shadow padding-md"
  [ngClass]="{'card-container-shadow': !removeClassCardContainerShadow}">
  <div nz-col nzSpan="24">

    <!--Header-->
    <ng-container>
      <div nz-row nzJustify="space-between" nzAlign="middle">
        <div nz-col class="text-subtitle-bold-upper" *ngIf="!withoutHeader">
          <p>Cédulas</p>
        </div>
        <div nz-col *ngIf="!limit || this.licenses.length <limit">
          <button nz-button [disabled]="disabled" class="btn-default
            align-self-end" type="button" nzType="default"
            (click)="onAddNewLicense()">
            <i nz-icon nzType="idcard" nzTheme="outline"></i>
            Nuevo
          </button>
        </div>
      </div>
      <p class="text-info mb-xs" *ngIf="this.licensesWithId?.length> 0 && description">{{ description }}</p>
    </ng-container>
    <!-- /Header -->

    <!--Content-->
    <div class="tw-mt-5">
      <div *ngFor="let license of this.licensesWithId; index as i" [formGroupName]="license.formId">
        <div class="d-flex tw-relative" @fadeInAnimation>
          <div class="element">
            <input
             maxlength="10"
              minlength="5"
              [ngStyle]="{'width': (license.item.length + 1) + 'ch', 'min-width': '40px'}"
              [hidden]="!form.get(license.formId).get('view').get('item').value"
              type="text"
              #item
              nz-input
              formControlName="item"
              (blur)="onHideValue(license.formId, 'item', '-------')"
              >
            <p *ngIf="!form.get(license.formId).get('view').get('item').value" (click)="onShowValue(license.formId, 'item', item)">
              {{form.get(license.formId).get('itemPlaceholder').value}}
            </p>
          </div>
          <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar" class="delete icon-action danger" (click)="onDeleteLicense(license.formId)">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </div>
        </div>
        <app-message-field [field]="form.get(license.formId).get('item')"></app-message-field>
        <p nz-typography [nzType]="'danger'" *ngIf="license.isEqual" @fadeInAnimation style="font-size: 0.7em;">
          Cédula repetida
        </p>
      </div>
    </div>
  </div>
</form>
